import { jsx as l } from "react/jsx-runtime";
const d = (e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ...e,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentcolor",
        fillRule: "evenodd",
        d: "M21.5 12.93a1 1 0 0 0 0-1.81L4.176 2.987l-.077-.033a1.55 1.55 0 0 0-2 1.973l2.062 6.186h9.256a1 1 0 1 1 0 2H4.1L2.1 19.121a1.55 1.55 0 0 0 2.077 1.94z",
        clipRule: "evenodd"
      }
    )
  }
);
export {
  d as default
};
